"use client";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useIsEligibleForMobileLoggedOutNavWithCartSignUp } from "@faire/deprecated-retailer-visitor-shared/components/Header/__internal__/useIsEligibleForMobileLoggedOutNavWithCartSignUp";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BottomDrawer } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/BottomDrawer";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { throttleIfPossible } from "@faire/web/common/globals/throttleIfPossible";
import { Button } from "@faire/web/slate/Button";
import { Flex } from "@faire/web/slate/Layout/Flex";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import { useEffect, useMemo, useState } from "react";

import { useNavigateAndHideMenu } from "../Header/mobile/Navigation/useNavigateAndHideMenu";

export const LoggedOutSignUpDrawer: React.FC = () => {
  const isEligibleForMobileLoggedOutNavWithCartSignUp =
    useIsEligibleForMobileLoggedOutNavWithCartSignUp();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { navigateToSignUp } = useNavigateAndHideMenu();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const throttledHandleScroll = useMemo(
    () =>
      throttleIfPossible(() => {
        const shouldShowDrawer = getShouldShowDrawer();

        if (shouldShowDrawer) {
          if (!isDrawerOpen) {
            setIsDrawerOpen(true);
          }
        } else {
          setIsDrawerOpen(false);
        }
      }, 300),
    []
  );

  useEffect(() => {
    getWindow()?.addEventListener("scroll", throttledHandleScroll, {
      passive: true,
    });

    return () => {
      getWindow()?.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [throttledHandleScroll]);

  const shouldShowSignUpButton =
    isEligibleForMobileLoggedOutNavWithCartSignUp && !isLoggedInRetailer;

  if (shouldShowSignUpButton) {
    return (
      <BottomDrawer isOpen={isDrawerOpen}>
        <Flex align="center" justify="center" className="p-4">
          <Button
            width="100%"
            onClick={() =>
              navigateToSignUp(
                undefined,
                {
                  sourceId: "mobile_bottom_drawer_signup_cta",
                },
                SignUpType.GENERIC
              )
            }
            data-test-id="bottomDrawerSignUpButton"
          >
            <StrictLocalMsg
              id="7m/igv"
              defaultMessage="Sign up"
              description={{
                text: "Sign up button",
              }}
            />
          </Button>
        </Flex>
      </BottomDrawer>
    );
  }
  return null;
};

const MINIMUM_SCROLL_THRESHOLD = 300;

const getShouldShowDrawer = () => {
  const window = getWindow();
  const scrollPosition = window?.scrollY ?? 0;
  return scrollPosition > MINIMUM_SCROLL_THRESHOLD;
};
